module.exports = __webpack_public_path__ + "img/payment-processing.5e5e543a.gif";